// Test Paywall Registry
// Add imports for your test paywall JSON files here
import { NamiInitialConfig } from "@namiml/web-sdk";

type FullInitialConfig = Exclude<NamiInitialConfig, { initial_config: string }>;
type NamiPaywalls = FullInitialConfig['paywalls'];
type NamiPaywall = NonNullable<NamiPaywalls>[number];

export const testPaywallFiles: Record<string, NamiPaywall> = {
  'basic-animations': require('./basic-animations.json'),
  // Add more test paywall imports here...
};

export default testPaywallFiles;
